import { render, staticRenderFns } from "./Xulosalar.vue?vue&type=template&id=aa94d006"
import script from "./Xulosalar.vue?vue&type=script&lang=js"
export * from "./Xulosalar.vue?vue&type=script&lang=js"
import style0 from "./Xulosalar.vue?vue&type=style&index=0&id=aa94d006&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports